import BudgetEdit from "../Components/BudgetEdit";

function Edit() {
    return (
        <BudgetEdit />
    );
}

export default Edit;